/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
//import * as auth from "../redux/AuthRedux";
//import { getUserByToken } from "../redux/AuthCRUD";
import { shallowEqual, useDispatch } from "react-redux";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { useSelector } from "react-redux";
//import { RootState } from "setup";
import { UserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { YesNoAlert } from "cpl-react-common/components/Alerts/YesNo";
import { IAuthenticationService } from "services/AuthenticationService";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { validateUser, verifyUser } from "./login/components/LoginPageSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { actions } from "./redux/AuthRedux";

const LoginLinkHandler: React.FC = () => {
  const authService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  const { emailAddress: emailAddress, password: password } = useParams();
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const navigate = useNavigate();
  //const [searchParams] = useSearchParams();

  const [displayLogOutAlert, setDisplayLogOutAlert] = useState(false);
  const userLoggedIn = useRef(false);

  //const currentUser = useSelector<RootState, UserModel | undefined>(({ auth }) => auth.user, shallowEqual);
  //const redirect = searchParams.get("redirect");

  const logInUserFromToken = useCallback(async () => {
    try {
      thunkDispatch(validateUser({ emailAddress: emailAddress!, password: password! }));
      thunkDispatch(
        verifyUser({
          emailAddress: emailAddress!,
          password: password!,
          oneTimePassword: "123456",
        })
      );

      //dispatch(auth.actions.login(cplToken));
      userLoggedIn.current = true;
    } catch (error) {
      console.error(error);
      dispatch(actions.logout());
      navigate("/auth");
    }
  }, [thunkDispatch, emailAddress, password, dispatch, navigate]);

  // const redirectUserAfterLogIn = useCallback(() => {
  //   navigate(redirect !== null ? `/${redirect}` : "/dashboard");
  // }, [redirect, navigate]);

  useEffect(() => {
    const handleLoginLink = async () => {
      // if (loginToken !== undefined) {
      //   if (currentUser === undefined) {
      await logInUserFromToken();
      // } else {
      //   const userFromToken = await getUserByToken(loginToken);
      //   userFromToken.userID === currentUser.userID
      //     ? navigate(redirect !== null ? `/${redirect}` : "/dashboard")
      //     : setDisplayLogOutAlert(true);
      // }
      // } else {
      navigate("/dashboard");
      // }
    };

    handleLoginLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (userLoggedIn.current && currentUser) {
  //     redirectUserAfterLogIn();
  //   }
  // }, [currentUser, redirectUserAfterLogIn]);

  // const handleLogOutAlertAnswer = (answer: boolean) => {
  //   if (answer) {
  //     dispatch(auth.actions.logout());
  //     logInUserFromToken();
  //   } else {
  //     navigate("/dashboard");
  //   }
  // };

  return (
    <>
      {/* <YesNoAlert
        showAlert={displayLogOutAlert}
        alertTitle="User Log Out"
        alertText="A user is already logged in on this device. Would you like to log them out?"
        callBack={handleLogOutAlertAnswer}
        style={Style.Warning}
      /> */}
    </>
  );
};

export default LoginLinkHandler;
